import { render, staticRenderFns } from "./BasicAlertModal.vue?vue&type=template&id=08292d37&scoped=true"
import script from "./BasicAlertModal.vue?vue&type=script&lang=js"
export * from "./BasicAlertModal.vue?vue&type=script&lang=js"
import style0 from "./BasicAlertModal.vue?vue&type=style&index=0&id=08292d37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08292d37",
  null
  
)

export default component.exports